module.exports = __webpack_public_path__ + "static/media/Անձրև.d74e853e.mp3";